import { Hero } from "../components/Hero";
import { ClientsMarquee } from "../components/ClientsMarquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Showcase } from "../components/Showcase";
import { Testimonial } from "../components/Testimonial";

export function Home() {
  return (
    <main>
      <Hero />
      <ClientsMarquee />
      <About />
      <Services />
      <Showcase />
      <Testimonial />
    </main>
  );
}
